import FlowEnum from '../types/FlowEnum';
import { GlobalStateAccess } from '../state/persistence';

const FlowService = {
  isCheckBusiness(): boolean {
    const { appStore } = GlobalStateAccess();

    return appStore.flow === FlowEnum.CHECK_BUSINESS;
  },
  isCheckPrivate(): boolean {
    const { appStore } = GlobalStateAccess();

    return appStore.flow === FlowEnum.CHECK_PRIVATE;
  },
  isCheck(): boolean {
    const { appStore } = GlobalStateAccess();

    return appStore.flow === FlowEnum.CHECK_PRIVATE || appStore.flow === FlowEnum.CHECK_BUSINESS;
  },
};

export default FlowService;
